module.exports = __webpack_public_path__ + "img/Icon_Tiktok.58aeb9a0.svg";